export default "__VITE_ASSET__fa164984__"